import { createSelector } from '@reduxjs/toolkit';
import menusSelector from './menus';

const sidebarAnimationSelector = createSelector(menusSelector, (menus) => menus.sidebarAnimation);

export default sidebarAnimationSelector;
